module.exports = __webpack_public_path__ + "static/media/04(2).a49a6f3a.jpg";